const initialState = {
  correctionReasons: {
    data: [],
    loading: 'idle',
  },
};

export default initialState;
